import "./style.scss";
import BoxError from "../../LoginComponent/BoxError";
import BoxLegal from "../../LoginComponent/BoxLegal";
import BoxAlert from "../../LoginComponent/BoxAlert";
import Toggle from "../../LoginComponent/Toggle";
import axios from "axios";
import { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import * as Yup from "yup";
import Loading from "../../LoadingComponent";

export default function Register() {
    const { t } = useTranslation();
    const passwordRef = useRef();
    const uuid = uuidv4();
    const [error, setError] = useState(false);
    const [dataObj, setDataObj] = useState(null);
    const [complete, setComplete] = useState(false);
    const [loading, setLoading] = useState(false);

    const formSchema = Yup.object().shape({
        namePrefix: Yup.string().required(t("error_required_nameTitle")),
        role: Yup.string().required(t("error_required_nameTitle")),
        // nameTitle: Yup.string().required(t("error_required_nameTitle")),
        firstname: Yup.string().required(t("error_required_firstName")),
        lastname: Yup.string().required(t("error_required_lastName")),
        parent_organization: Yup.string().required(t("error_required_parentOrganization")),
        parent_organization_position: Yup.string().required(t("error_required_parentOrganizationPosition")),
        // phoneNumber: Yup.string()
        //     .required(t("error_required_phone_number"))
        //     .matches(/^[0-9]*$/, t("error_matches_phone_number"))
        //     .min(10, t("error_min_phone_number")),
        email: Yup.string().email(t("error_matches_email")).required(t("error_required_email")),
        password: Yup.string().required(t("error_required_password")).min(8, t("error_min_character")),
        confirmPwd: Yup.string()
            .required(t("error_confirm_password"))
            .oneOf([Yup.ref("password")], t("error_confirm_current_new_password")),
        accept: Yup.boolean().oneOf([true], ""),
    });

    const formOptions = { resolver: yupResolver(formSchema) };
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm(formOptions);

    async function onSubmit(data, event) {
        console.log(data);
        event.preventDefault();
        setLoading(true);
        setError(false);

        const {
            firstname,
            lastname,
            password,
            email,
            nameTitle,
            namePrefix,
            parent_organization,
            parent_organization_position,
            role,
        } = data;

        axios
            .post("/api/user/register", {
                firstname,
                lastname,
                password,
                email,
                nameTitle,
                namePrefix,
                parent_organization,
                parent_organization_position,
                role,
            })
            .then(({ data }) => {
                setLoading(false);
                if (data.status == 200) {
                    setComplete(true);
                } else {
                    setDataObj({
                        email: data.email == 400 && email,
                    });
                    setError(true);
                }
            });
    }

    return (
        <section className="register-page section-login-register-template">
            <img
                src="/img/mbog-official-logo.png"
                alt=""
                style={{
                    margin: "0 auto 40px",
                    width: "200px",
                    height: "auto",
                    display: "block",
                }}
            />
            {loading && <Loading />}
            {complete ? (
                <BoxAlert title={t("thank_to_register")} paragraph={t("check_email_to_login")} />
            ) : (
                <div className="box-login-register-template box-register">
                    <div className="wrapper-form">
                        <h2>{t("register")}</h2>
                        <Toggle />
                        {error && (
                            <BoxError>
                                <>
                                    {dataObj.phoneNumber && (
                                        <li>
                                            {t("profile_phone_number")} {dataObj.phoneNumber} {t("have_data")}
                                        </li>
                                    )}
                                    {dataObj.email && (
                                        <li>
                                            {t("profile_email")} {dataObj.email} {t("have_data")}
                                        </li>
                                    )}
                                </>
                            </BoxError>
                        )}
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="container-top">
                                {/* <div className={`group-input ${errors.phoneNumber ? "error" : ""}`}>
                                    <label htmlFor="">{t("profile_phone_number")}</label>
                                    <input
                                        name="phoneNumber"
                                        type="text"
                                        {...register("phoneNumber", {
                                            required: true,
                                        })}
                                    />
                                    <span className="error">{errors.phoneNumber?.message}</span>
                                </div> */}

                                <div className={`group-input`}>
                                    <label htmlFor="">{t("profile_nameTitle")}</label>
                                    <input
                                        type="text"
                                        name="nameTitle"
                                        // {...register("nameTitle", {
                                        //     required: true,
                                        // })}
                                    />
                                    {/* <span className="error">{errors.nameTitle?.message}</span> */}
                                </div>
                                <div
                                    className={`group-input ${errors.namePrefix ? "error" : ""}`}
                                    style={{ paddingTop: "5px", display: "flex", flexDirection: "row" }}
                                >
                                    <label>
                                        <input type="radio" name="namePrefix" value="นพ." {...register("namePrefix")} />
                                        นพ.
                                    </label>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <label>
                                        <input type="radio" name="namePrefix" value="พญ." {...register("namePrefix")} />
                                        พญ.
                                    </label>
                                </div>
                                <div className={`group-input ${errors.firstname ? "error" : ""}`}>
                                    <label htmlFor="">{t("profile_firstName")}</label>
                                    <input
                                        type="text"
                                        name="firstname"
                                        {...register("firstname", {
                                            required: true,
                                        })}
                                    />
                                    <span className="error">{errors.firstname?.message}</span>
                                </div>
                                <div className={`group-input ${errors.lastname ? "error" : ""}`}>
                                    <label htmlFor="">{t("profile_lastName")}</label>
                                    <input
                                        type="text"
                                        name="lastname"
                                        {...register("lastname", {
                                            required: true,
                                        })}
                                    />
                                    <span className="error">{errors.lastname?.message}</span>
                                </div>
                                <div className={`group-input ${errors.parent_organization ? "error" : ""}`}>
                                    <label htmlFor="">{t("profile_parent_organization")}</label>
                                    <input
                                        type="text"
                                        name="parent_organization"
                                        {...register("parent_organization", {
                                            required: true,
                                        })}
                                    />
                                    <span className="error">{errors.parent_organization?.message}</span>
                                </div>
                                <div className={`group-input ${errors.parent_organization_position ? "error" : ""}`}>
                                    <label htmlFor="">{t("profile_parent_organization_position")}</label>
                                    <input
                                        type="text"
                                        name="parent_organization_position"
                                        {...register("parent_organization_position", {
                                            required: true,
                                        })}
                                    />
                                    <span className="error">{errors.parent_organization_position?.message}</span>
                                </div>
                                <div className={`group-input ${errors.email ? "error" : ""}`}>
                                    <label htmlFor="">{t("profile_email")}</label>
                                    <input
                                        type="text"
                                        name="email"
                                        {...register("email", {
                                            required: true,
                                        })}
                                    />
                                    <span className="error">{errors.email?.message}</span>
                                </div>
                                <div className={`group-input ${errors.password ? "error" : ""}`}>
                                    <label htmlFor="">{t("password")}</label>
                                    <input
                                        ref={passwordRef}
                                        name="password"
                                        type="password"
                                        {...register("password")}
                                    />
                                    <span className="error">{errors.password?.message}</span>
                                </div>
                                <div className={`group-input ${errors.confirmPwd ? "error" : ""}`}>
                                    <label htmlFor="">{t("confirm_password")}</label>
                                    <input name="confirmPwd" type="password" {...register("confirmPwd")} />
                                    <span className="error">{errors.confirmPwd?.message}</span>
                                </div>
                                <div
                                    className={`group-input ${errors.role ? "error" : ""}`}
                                    style={{ paddingTop: "10px" }}
                                >
                                    <label>
                                        <input
                                            type="radio"
                                            name="role"
                                            value="teacher"
                                            {...register("role", {
                                                required: true,
                                            })}
                                        />
                                        ลงทะเบียนเพื่อเป็นผู้สอน
                                    </label>
                                </div>
                                <div className={`group-input ${errors.role ? "error" : ""}`}>
                                    <label>
                                        <input
                                            type="radio"
                                            name="role"
                                            value="student"
                                            {...register("role", {
                                                required: true,
                                            })}
                                        />
                                        ลงทะเบียนเพื่อเป็นผู้เรียน
                                    </label>
                                </div>

                                <div className={`group-check ${errors.accept ? "error" : ""}`}>
                                    <div>
                                        <label htmlFor="accept" className="checkbox">
                                            {t("privacy_policy_detail")}{" "}
                                            <a href={`/privacy-policy`}>{t("privacy_policy")}</a>
                                            <input type="checkbox" name="accept" id="accept" {...register("accept")} />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                    <span className="error">{errors.accept?.message}</span>
                                </div>
                                <input type="submit" value={t("register")} />
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </section>
    );
}
